import axios from 'axios';
import { AUTOCOMPLETE_FAILED, AUTOCOMPLETE_FULFILLED } from '../constants/actions/autocompleteActions';
import { AUTOCOMPLETE } from '../constants/paths/api';

export const autocompleteFulfilled = autocompleteResults => ({
	type: AUTOCOMPLETE_FULFILLED,
	payload: {
		autocompleteResults,
	},
});

export const autocompleteFailed = error => ({
	type: AUTOCOMPLETE_FAILED,
	payload: {
		error,
	},
});

export const fetchAutoCompleteResults = (): any => {
	return async dispatch => {
		try {
			const response = await axios(`${AUTOCOMPLETE}`);
			dispatch(autocompleteFulfilled(response.data));
		} catch (error) {
			dispatch(autocompleteFailed(error));
		}
	};
};
